import { cloneDeep } from 'lodash-es';
import merge from '@/common/utils/merge';
import hash from '@/common/utils/hash';
import hasSystemTag from '@/common/utils/model.util';

export default class Model {
  attributes: any;
  hash: string;

  constructor(attributes) {
    this.hash = '';

    Object.defineProperty(this, 'attributes', {
      value: attributes,
      configurable: false,
      writable: true
    });

    this.updateHash();
  }

  get id(): ID {
    return (this.attributes.id || '').toString();
  }

  get name(): string {
    return this.attributes.name || this.id;
  }

  get status(): string {
    return this.attributes.status || '';
  }

  get isLoading(): boolean {
    return false;
  }

  get isDeletable(): boolean {
    return true;
  }

  get tags(): string[] {
    return this.attributes.tags || [];
  }

  get isSystem(): boolean {
    return hasSystemTag(this.tags);
  }

  merge(attributes): this {
    this.attributes = merge(attributes, this.attributes);
    this.updateHash();
    return this;
  }

  toJS() {
    return cloneDeep(this.attributes);
  }

  updateHash(): void {
    this.hash = hash(this.attributes);
  }
}
